//https://codepen.io/stefen/pen/wybOYy
var $ = require('jquery');

$(document).ready(function(){

	var $input = $('.js-dashboard-form .field--element');

	$input
		.on('focus', function() {
			$(this).addClass('active')
				.parent()
				.addClass('active');
		})
		.blur();

	$input
		.focusout(function() {
			if (!$(this).val()) {
				$(this)
					.parent()
					.removeClass('active');
			} else {
				$(this)
					.parent()
					.addClass('active');
			}
		})
		.focusout(); // focusout event for prefilled forms
});
